import { render, staticRenderFns } from "./DashboardEggsRegister.vue?vue&type=template&id=4f2e16b4&scoped=true"
import script from "./DashboardEggsRegister.vue?vue&type=script&lang=js"
export * from "./DashboardEggsRegister.vue?vue&type=script&lang=js"
import style0 from "./DashboardEggsRegister.vue?vue&type=style&index=0&id=4f2e16b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2e16b4",
  null
  
)

export default component.exports